module.exports = __webpack_public_path__ + "img/error.69fb7806.png";